import { Button, StatusMessage } from '@krp/ui-kit'
import type { QueryView } from '@krp/client-runtime'

/**
 * Не-«готовые» состояния запроса одинаково во всех окнах 1С: загрузка, пусто,
 * нет входа, нет доступа, недоступно, ошибка. Текст сервера — дословно
 * (ADR-8), код и корреляция — для отчёта об ошибке.
 */
export function QueryState({
  query,
  emptyText,
  onRetry,
}: {
  query: QueryView
  emptyText: string
  onRetry?: () => void
}) {
  const meta =
    query.error !== null && query.error.correlationId !== null
      ? `Код: ${query.error.code} · запрос ${query.error.correlationId}`
      : query.error !== null
        ? `Код: ${query.error.code}`
        : undefined
  const retry =
    onRetry === undefined ? undefined : (
      <Button variant="secondary" onClick={onRetry}>
        Повторить
      </Button>
    )
  switch (query.status) {
    case 'idle':
    case 'loading':
      return <StatusMessage kind="loading" title="Загрузка…" />
    case 'empty':
      return <StatusMessage kind="empty" title={emptyText} />
    case 'unauthorized':
      return <StatusMessage kind="unauthorized" title="Сессия завершена" text="Войдите снова, чтобы продолжить." />
    case 'forbidden':
      return (
        <StatusMessage kind="forbidden" title="Нет доступа" text={query.error?.message} {...(meta ? { meta } : {})} />
      )
    case 'unavailable':
      return (
        <StatusMessage
          kind="unavailable"
          title="1С или служба недоступна"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          {...(retry ? { action: retry } : {})}
        />
      )
    case 'error':
      return (
        <StatusMessage
          kind="error"
          title="Ошибка"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          {...(retry ? { action: retry } : {})}
        />
      )
    case 'ready':
      return null
  }
}
